import React from 'react';
import { Container } from 'react-bootstrap';

import { connect } from 'react-redux';
import { CustomThemes } from '../utils/custom-themes';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface PageHeaderProps {
  pageTitle: string;
  customHeader: boolean;
}

export const PageHeader = ({ pageTitle, customHeader }: PageHeaderProps) => {
  CustomThemes();
  return (
    <div className={customHeader ? '' : 'bg-light-gray border border-bottom border-secondary'}>
      <Container>
        <div className='d-flex py-3 w-45'>
          {customHeader ? (
            <span className='main-header'>{pageTitle}</span>
          ) : (
            <h3 className='font-weight-bold'>{pageTitle}</h3>
          )}
        </div>
      </Container>
    </div>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export const ConnectedPageHeader = connect(mapStateToProps, mapDispatchToProps)(PageHeader);
